import { Box, View } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

export const Disclaimer = withTypography({ variant: 'copyTwo', mb: '$3' });

export const ButtonWrapper = Box.withConfig({
  marginTop: '$3',
});

export const MarketDisclaimer = withTypography({
  variant: 'copyTwo',
  mb: '$4',
  textAlign: 'center',
});

export const SignUpContainer = View;

export const FieldContainer = Box.withConfig({
  marginBottom: '$1',
});

export const ErrorMessage = withTypography({
  variant: 'copyOne',
  color: getDesignToken('color-error'),
  fontSize: 'xs',
});
